import {useConfigStore} from "~/store/config";
import {useUiStore} from "~/store/ui";
import useAlgoliaSearch from "~/composables/useAlgoliaSearch";
import type {SellerClub, SellerPerson} from "~/constants/types/seller";

export default defineNuxtRouteMiddleware(async (to) => {
  // skip middleware on client side entirely
  if (import.meta.client) return;

  const config = useConfigStore();
  const uiStore = useUiStore();
  const {algoliaClubSearch, algoliaSellerSearch} = useAlgoliaSearch();
  const url = to.fullPath;
  const clubCookie = useCookie<SellerClub>('club', {maxAge: 3600 * 24 * 182, path: '/'});
  const sellerCookie = useCookie<SellerPerson>('seller', {maxAge: 3600 * 24 * 182, path: '/'});
  const isSeller = useCookie<boolean>('isSeller', {maxAge: 3600 * 24 * 182, path: '/'});
  const invoiceRejected = useCookie<boolean>('invoiceRejected', {
    maxAge: 3600 * 24 * 182,
    path: '/',
    default: () => false
  });
  if ((url.includes('seller') || to.query?.sellerid) && !to.query?.seller ) {
    const splitRoute = url.split('/');
    let sellerId = null as null | string;
    if (to.query?.sellerid) {
      sellerId = to.query.sellerid as string;
    } else if (to.query?.sellerId) {
      sellerId = to.query.sellerId as string;
    } else {
      if (splitRoute[3] && splitRoute[3] !== '') {
        sellerId = splitRoute[3];
      }
    }
    if (sellerId) {
      const sellerRes = await algoliaSellerSearch(sellerId);
      const today = new Date();
      today.setHours(2, 0, 0, 0); // add two hours to compensate time diff
      if (sellerRes && sellerRes.length === 1) {
        // Found a seller, checking that club is active
        const clubRes = await algoliaClubSearch(sellerRes[0].RoundID);
        if (clubRes) {

          if (clubRes.length !== 1 || !clubRes[0].Active) {
            // Club is not active
            uiStore.sellerDialogSettings.clubInactive = true;
            uiStore.showSellerDialog = true;
          } else {
            console.log(clubRes[0]);
            // We have both our seller and our club
            if (clubRes[0].DeadlineDate?.length > 0 && Date.parse(clubRes[0].DeadlineDate) < today && !clubRes[0].NoDeadlineDate) {
              // Club is past deadline date
              uiStore.sellerDialogSettings.clubPastDeadline = true;
              invoiceRejected.value = true;
              if (!to.query?.id != '') {
                // Don't show dialog if it's a create cart link
                uiStore.showSellerDialog = true;
              }
            }
            config.clubCookie = clubRes[0];
            config.sellerCookie = sellerRes[0];
            config.isSeller = true;
            clubCookie.value = clubRes[0];
            sellerCookie.value = sellerRes[0];
            isSeller.value = true;
          }
        } else {
          console.log('Club error');
          uiStore.sellerDialogSettings.clubError = true;
          uiStore.showSellerDialog = true;
          isSeller.value = true;
        }
      } else {
        console.log('Seller Error');
        uiStore.sellerDialogSettings.sellerError = true;
        uiStore.showSellerDialog = true;
        isSeller.value = true;
      }
    }
  } else if (clubCookie.value && sellerCookie.value) {
    config.clubCookie = clubCookie;
    config.sellerCookie = sellerCookie;
    config.isSeller = true;
    isSeller.value = true;
  } else if (to.query?.seller === 'true') {
    isSeller.value = true;
    if (!sellerCookie?.value || !clubCookie?.value) {
      uiStore.sellerDialogSettings.sellerMissing = true;
      uiStore.showSellerDialog = true;
    }
  } else {
    console.log('Cookies are not set.');
  }

});
